import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=81ca91d0&scoped=true"
import script from "./FormDetail.vue?vue&type=script&lang=js"
export * from "./FormDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ca91d0",
  null
  
)

export default component.exports